import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { translate as t } from '@/lib/i18n';
import { workspaceSettingsApi } from '@/api';
import { accountKeys, analyticsKeys, workspaceSettingsKeys } from '@/lib/queryKeys';

export function useWorkspaceApiKey() {
  const qc = useQueryClient();
  const invalidate = () =>
    Promise.all([
      qc.invalidateQueries({ queryKey: workspaceSettingsKeys.all }),
      qc.invalidateQueries({ queryKey: accountKeys.all }),
      qc.invalidateQueries({ queryKey: analyticsKeys.all }),
    ]);
  const save = useMutation({
    mutationFn: workspaceSettingsApi.setRapidApiKey,
    onSuccess: async () => {
      await invalidate();
      toast.success(t('Clé RapidAPI enregistrée', 'RapidAPI key saved'));
    },
  });
  const remove = useMutation({
    mutationFn: workspaceSettingsApi.removeRapidApiKey,
    onSuccess: async () => {
      await invalidate();
      toast.success(t('Clé retirée', 'Key removed'));
    },
  });
  return { save, remove };
}
